export function sortData<T>(data: T[], category: SortCategory): T[] {
  if (!category) return [...data];
  const cleanCategory = typeof category.name === "string" ? category.name.charAt(0).toLowerCase() + category.name.slice(1).replaceAll(" ","") : category.name;
  return [...data].sort((a, b) => {
    const aRaw = a[cleanCategory as keyof T];
    const bRaw = b[cleanCategory as keyof T];

   
    const aValue = aRaw ?? (typeof bRaw === "string" ? "" : 0);
    const bValue = bRaw ?? (typeof aRaw === "string" ? "" : 0);

    if (category.direction === true) {
      if (typeof aValue === "boolean" && typeof bValue === "boolean") return aValue.toString().localeCompare(bValue.toString());
      if (typeof aValue === "string" && typeof bValue === "string") return aValue.localeCompare(bValue);
      if (typeof aValue === "number" && typeof bValue === "number") return aValue - bValue;
    } else {
      if (typeof aValue === "boolean" && typeof bValue === "boolean") return bValue.toString().localeCompare(aValue.toString());
      if (typeof aValue === "string" && typeof bValue === "string") return bValue.localeCompare(aValue);
      if (typeof aValue === "number" && typeof bValue === "number") return bValue - aValue;
    }

    return 0;
  });
}


export type SortCategory = {
  name: string | number;
  direction: boolean;
}

export function setMonthDays(curDate: Date):Date[]  {
    const dayOfWeek = curDate.getDay();
    let firstDay = new Date(curDate);
     if (dayOfWeek == 0) {
     
      firstDay.setDate(curDate.getDate() - 6);
    }
    else if (dayOfWeek !== 1) {
     
      firstDay.setDate(curDate.getDate() - (dayOfWeek - 1));
    }

    const daysInMonth = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0).getDate();
    const totalCells = Math.ceil((firstDay.getDay() + daysInMonth) / 7) * 7;
   

 
    const result: Date[] = [];
    for (let i = 0; i < totalCells; i++) {
      result.push(new Date(firstDay));
      firstDay.setDate(firstDay.getDate() + 1);
    }
    return result;
    

  };

    export function getCalendarWeek  (date: Date) :number {
    const temp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    temp.setHours(0, 0, 0, 0);
    temp.setDate(temp.getDate() + 3 - ((temp.getDay() + 6) % 7));
    const week1 = new Date(temp.getFullYear(), 0, 4);
    return (
      1 +
      Math.round(((temp.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7)
    );
  };


  
  //return string
export function blobToDataURL(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const res = reader.result;
      if (typeof res === "string") resolve(res); // "data:image/...;base64,...."
      else reject(new Error("Unexpected FileReader result"));
    };

    reader.onerror = () => reject(reader.error ?? new Error("Failed to read blob"));
    reader.onabort = () => reject(new Error("Read aborted"));

    reader.readAsDataURL(blob);
  });
}
